import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import './ConfirmaPedido.css';
import services from '../../services/index';
import Header from '../header/Header';
export default class ConfirmaPedido extends Component {
    constructor(props) {
        super(props);

        this.state = {
            redirect: false,
            aguardando: true,
            img: 'assets/pizza-slice.png',
            texto: 'Aguardando confirmação da loja...',
            color: '#fff',//"url('assets/background.png')",
            interval: null,
            colorText: '#000'
        }


    }

    timer = null;

    redirect = () => {
        this.setState({ redirect: true });
    }

    componentDidMount() {
        services.cleanTemps();
        this.startTimer();
    }

    componentWillUnmount() {
        this.stopTimer();
    }


    verificaStatus = async () => {
        if (this.timer) {

            // setTimeout(() => {
            //     this.setState({img : 'assets/happy.png', texto : 'Seu pedido foi aceito', color : '#fff'}); 
            // }, 800);
            // return;
            this.stopTimer();
            let r = await services.getStatusPedido(this.props.numeropedido);
            if (r.status) {
                if (r.status === 'CONFIRMADO') {
                    this.setState({ img: 'assets/happy.png', texto: 'A loja confirmou seu pedido', color: '#fff', colorText: "#000" });
                    return;
                }
            }
        }
        this.startTimer();
    }

    stopTimer() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    }

    startTimer() {
        this.timer = setInterval(this.verificaStatus, 2000);

    }


    render() {
        if (this.state.redirect) {
            return <Redirect to={{ pathname: "/", state: { from: this.props.location } }} />
        } else {


            return (
                <div>
                    <Header logado={true} where="lancamento" />
                    <div className="ConfirmaPedidoPage" style={{ background: this.state.color }}>


                        <div className="content-message">
                            <div className="footer-content-pedido">
                                <img src={this.state.img} />
                            </div>
                        </div>

                        <p style={{ color: this.state.colorText, fontFamily: "'Arima Madurai', cursive !important;", fontSize: '22px' }}>{this.state.texto}</p>
                        <p style={{ color: '#FFF', fontFamily: "'Arima Madurai', cursive !important;", fontSize: '22px' }}><strong>Numero do Pedido : </strong>{this.props.numeropedido}</p>



                        <button type="button" className="btn btn-success btn-pedidoEnviado" onClick={this.redirect}>Voltar a Tela Principal</button>

                    </div>
                </div>
            )
        }
    }

}




// <p>Seu pedido foi enviado com sucesso.</p>
// <p>O Número do pedido é : <span style={{ fontWeight: "bold" }}>{this.props.numeropedido}</span></p>
// <button type="button" className="btn btn-success btn-pedidoEnviado" onClick={this.redirect}>OK</button>